module.exports = __webpack_public_path__ + "img/white2.23c05773.svg";